export enum FetchStatus {
	IDLE = 'idle',
	LOADING = 'loading',
	FAILED = 'failed',
}
